// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.citytopbanner {
  display: flex;
  position: relative;
  justify-content: center;
}
.cityheading {
  margin-top: 120px;
  margin-bottom: 24px;
  text-align: center;
  color: #ba1e24;
  font-family: Thicker;
  font-size: 54px;
  line-height: 60px;
  font-style: normal;
  font-weight: 500;
  padding: 0 20px;
  text-transform: uppercase;
}
.directionButton{
cursor: pointer;
display: inline;
color: #ba1e24;
padding: 0px;
margin-left: 20px;
background-color: rgba(255, 255, 255);
}
.cityButton{
  margin-top: 10px;
}
.image_wrapper_city {
  position: relative;
  width: 100% !important;
}
.citytopbanner img {
  width: 100%;
}


.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}


.aboutcity {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
}
.aboutcity p {
  color: #fff;
  text-align: center;
  font-family: Thicker !important;
  font-size: 20px;
  line-height: 24px;
  font-style: normal;
  font-weight: 700;
  text-transform: capitalize;
  padding: 6px 20px;
  margin: 0;
}
.cityregisterbutton {
  background-color: #ba1e24;
  font-family: lightThicker !important;
  color: #fff;
  padding: 10px;
}
.citydescription {
  padding: 20px 80px;
}
.obstaclesection {
  padding: 70px;
  background-image: url("https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/dcw/Find+your+race+(1).webp");
  width: 100%;
}
.headingandbutton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}
.obstacleheading {
  color: #fff;
  font-family: Thicker;
  font-size: 54px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.cityobstacletext {
  background-color: #BA1E24; /* Or any color you prefer */
  color: #fff;
  padding: 0 25px 5px 0px; 
}
.cityobstaclenumber{

}
.seeallbutton {
  background-color: #ba1e24;
  color: #fff;
  font-family: Thicker;
  padding: 6px;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  cursor: pointer;
}
.obstaclecardouterdiv {
  display: flex;
  justify-content: space-between;
  gap: 20px 20px;
}

.obstaclecard {
  /* height: 414px; */
  width: 30%;
  background-color: #fff;
  padding: 20px;
  align-items: center;
}

.obstaclecard img {
  width: 100%;
}
.cardobstaclename {
  color: #000;
  font-family: Thicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  margin-top: 5px;
  display: flex;
  justify-content: space-around;
}
.seeallbuttonmobile{
  display: none;
}
@media (min-width: 651px) and (max-width: 1023px) {
  .cityheading {
    font-size: 36px;
    line-height: 40px !important;
  }

    .aboutcity p {
      font-size: 15px !important;
      line-height: 20px;
      padding: 4px 10px;
      margin: 0;
    }
}
@media screen and (max-width: 650px) {
  .cityheading {
    font-size: 14px;
text-align: left;
    padding: 0 16px;
  }
  .cityheading {
    margin-top: 80px;
  }
  .aboutcity {
    position: relative;
  }
  .citytopbanner {
    display: block;
  }
  .aboutcity {
    align-items: start;
    padding: 20px;
  }
  .aboutcity p {
    color: #060505;
    font-size: 12px;
    text-align: left;
    line-height: 16px;
    padding: 4px 0;
    margin: 0;
  }
  .citydescription {
    padding: 5px 20px;
    font-size: 12px;
}
.seeallbutton {
  display: none;
}
.obstaclecardouterdiv {
  display: block;
}
.headingandbutton {
  justify-content: center;
}
.obstaclecard {
  width: 100%;
  margin-bottom: 20px;
}
.obstacleheading {
  font-size: 45px;
}
.obstaclesection {
  padding: 20px;
  object-fit: cover;
  background-image: url("https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/devil_circuit/Find+your+race+(3).webp");
}
.overlay {
  display: none;
}
.seeallbuttonmobile{
  display: flex;
  justify-content: center;
  background-color: #ba1e24;
  color: #fff;
  font-family: Thicker;
  padding: 6px;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  cursor: pointer;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/cityPage/citypage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;AACA,eAAe;AACf,eAAe;AACf,cAAc;AACd,YAAY;AACZ,iBAAiB;AACjB,qCAAqC;AACrC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,WAAW;EACX,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gHAAgH;EAChH,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB,EAAE,4BAA4B;EACvD,WAAW;EACX,uBAAuB;AACzB;AACA;;AAEA;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,eAAe;IACf,4BAA4B;EAC9B;;IAEE;MACE,0BAA0B;MAC1B,iBAAiB;MACjB,iBAAiB;MACjB,SAAS;IACX;AACJ;AACA;EACE;IACE,eAAe;AACnB,gBAAgB;IACZ,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,eAAe;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,0HAA0H;AAC5H;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA","sourcesContent":[".citytopbanner {\n  display: flex;\n  position: relative;\n  justify-content: center;\n}\n.cityheading {\n  margin-top: 120px;\n  margin-bottom: 24px;\n  text-align: center;\n  color: #ba1e24;\n  font-family: Thicker;\n  font-size: 54px;\n  line-height: 60px;\n  font-style: normal;\n  font-weight: 500;\n  padding: 0 20px;\n  text-transform: uppercase;\n}\n.directionButton{\ncursor: pointer;\ndisplay: inline;\ncolor: #ba1e24;\npadding: 0px;\nmargin-left: 20px;\nbackground-color: rgba(255, 255, 255);\n}\n.cityButton{\n  margin-top: 10px;\n}\n.image_wrapper_city {\n  position: relative;\n  width: 100% !important;\n}\n.citytopbanner img {\n  width: 100%;\n}\n\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n\n.aboutcity {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.aboutcity p {\n  color: #fff;\n  text-align: center;\n  font-family: Thicker !important;\n  font-size: 20px;\n  line-height: 24px;\n  font-style: normal;\n  font-weight: 700;\n  text-transform: capitalize;\n  padding: 6px 20px;\n  margin: 0;\n}\n.cityregisterbutton {\n  background-color: #ba1e24;\n  font-family: lightThicker !important;\n  color: #fff;\n  padding: 10px;\n}\n.citydescription {\n  padding: 20px 80px;\n}\n.obstaclesection {\n  padding: 70px;\n  background-image: url(\"https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/dcw/Find+your+race+(1).webp\");\n  width: 100%;\n}\n.headingandbutton {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 40px;\n}\n.obstacleheading {\n  color: #fff;\n  font-family: Thicker;\n  font-size: 54px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.cityobstacletext {\n  background-color: #BA1E24; /* Or any color you prefer */\n  color: #fff;\n  padding: 0 25px 5px 0px; \n}\n.cityobstaclenumber{\n\n}\n.seeallbutton {\n  background-color: #ba1e24;\n  color: #fff;\n  font-family: Thicker;\n  padding: 6px;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 500;\n  cursor: pointer;\n}\n.obstaclecardouterdiv {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px 20px;\n}\n\n.obstaclecard {\n  /* height: 414px; */\n  width: 30%;\n  background-color: #fff;\n  padding: 20px;\n  align-items: center;\n}\n\n.obstaclecard img {\n  width: 100%;\n}\n.cardobstaclename {\n  color: #000;\n  font-family: Thicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  margin-top: 5px;\n  display: flex;\n  justify-content: space-around;\n}\n.seeallbuttonmobile{\n  display: none;\n}\n@media (min-width: 651px) and (max-width: 1023px) {\n  .cityheading {\n    font-size: 36px;\n    line-height: 40px !important;\n  }\n\n    .aboutcity p {\n      font-size: 15px !important;\n      line-height: 20px;\n      padding: 4px 10px;\n      margin: 0;\n    }\n}\n@media screen and (max-width: 650px) {\n  .cityheading {\n    font-size: 14px;\ntext-align: left;\n    padding: 0 16px;\n  }\n  .cityheading {\n    margin-top: 80px;\n  }\n  .aboutcity {\n    position: relative;\n  }\n  .citytopbanner {\n    display: block;\n  }\n  .aboutcity {\n    align-items: start;\n    padding: 20px;\n  }\n  .aboutcity p {\n    color: #060505;\n    font-size: 12px;\n    text-align: left;\n    line-height: 16px;\n    padding: 4px 0;\n    margin: 0;\n  }\n  .citydescription {\n    padding: 5px 20px;\n    font-size: 12px;\n}\n.seeallbutton {\n  display: none;\n}\n.obstaclecardouterdiv {\n  display: block;\n}\n.headingandbutton {\n  justify-content: center;\n}\n.obstaclecard {\n  width: 100%;\n  margin-bottom: 20px;\n}\n.obstacleheading {\n  font-size: 45px;\n}\n.obstaclesection {\n  padding: 20px;\n  object-fit: cover;\n  background-image: url(\"https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/devil_circuit/Find+your+race+(3).webp\");\n}\n.overlay {\n  display: none;\n}\n.seeallbuttonmobile{\n  display: flex;\n  justify-content: center;\n  background-color: #ba1e24;\n  color: #fff;\n  font-family: Thicker;\n  padding: 6px;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 500;\n  cursor: pointer;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
